import styled from "styled-components";
import theme from "../../theme/theme";

export const MainWrapper = styled.div`
  margin: 0 10%;
  @media (max-width: 400px) {
    margin: 0 5%;
  }
`;

export const MainTitle = styled.h1`
  font-family: "Inter", sans-serif;
  font-size: 32px;
  font-weight: 600;
  color: ${theme.color.navy};
  margin-top: 40px;
  margin-bottom: -0.8rem;
  display: flex;
  @media (max-width: 400px) {
    margin-bottom: 0rem;
  }
`;

export const TopContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ButtonContainer = styled.div`
  display: flex;
  margin-bottom: -2.5rem;
`;

export const BottomContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: 50px;
  gap: 50px;
  @media (max-width: 800px) {
    flex-direction: column;
    justify-content: center;
    gap: 30px;
  }
`;

export const LeftContainer = styled.div`
  display: flex;
  width: 60%;
  flex-direction: column;
  @media (max-width: 800px) {
    width: 100%;
  }
`;

export const BookingContainer = styled.div`
  display: flex;
  width: auto;
  @media (max-width: 800px) {
    justify-content: center;
  }
`;

export const SecondaryTitle = styled.h2`
  font-family: "Inter", sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: ${theme.color.navy};
  // margin-top: 40px;
  margin-bottom: -0.2rem;
  margin-left: 0.5rem;
`;

export const Divider = styled.hr`
  border: 1.5px solid ${theme.color.silver};
  border-radius: 10px;
  width: 100%;
`;

export const Description = styled.p`
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: ${theme.color.black};
  margin-left: 0.5rem;
  line-height: 28px;
  `;

export const LocationDiv = styled.div`
  display: flex;
  margin: 10px 5%;
`;

export const GalleryContainer = styled.div`
  margin-top: 30px;
  margin-bottom: 20px;
`;
